<template>
    <div>
        <button v-if="isAffiliate" @click="resendSms()"
                class="button choice-button"
                :class="{'choice-button--disabled': retry>0}">
            <span>Renvoyer un nouveau code</span>
                <img src="/images/new_branding/retry.svg">
        </button>
        <!--<button @click="resendSms()"-->
        <!--        class="button choice-button"-->
        <!--        :class="{'retry-button&#45;&#45;disabled': retry>0}">-->
        <!--    <span>Reenviar novo código</span>-->
        <!--    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 16">-->
        <!--        <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">-->
        <!--            <path d="M8.3 1.5L14 8.2l-5.7 6.3M13.2 8H1"/>-->
        <!--        </g>-->
        <!--    </svg>-->
        <!--</button>-->
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import form_step_mixin from '../../../form_step_mixin'
import Echo from "laravel-echo";
import {get} from "vuex-pathify";

export default {
    mixins: [mixin, form_step_mixin],
    computed: {
        query_string: get('func_data/query_string'),
        isAffiliate(){
            return _.get(this.query_string, 'utm_medium') == 'affiliates';
        },
    },
    data() {
        return {
            retry: 0
        }
    },
    methods: {
        setEcho(){
            let echo = new Echo({
                broadcaster: 'pusher',
                key: process.env.MIX_PUSHER_APP_KEY,
                cluster: process.env.MIX_PUSHER_APP_CLUSTER,
                forceTLS: true
            });
            let match_token = this.$store.get('func_data/match_token');
            echo.channel('sms-verification-be-'+ match_token).listen('SMSVerification', (e) => {
                location.href='/thanks?redirected=1&is_site=1&match_token='+match_token;
            })
        },
        resendSms() {
            if (this.retry < 1) {
                this.retry++;
                return axios.post('/send_sms_thanks',
                    {
                        phone: this.$store.get('func_data/phone'),
                        match_token: this.$store.get('func_data/match_token'),
                        form_token: this.$store.get('func_data/form_token'),
                        lang: this.$store.get('func_data/lang'),
                        country: this.$store.get('func_data/country'),
                        is_test: this.$store.get('func_data/is_test'),
                    })
            }
        }
    },
    mounted() {
        this.setEcho();
    }
}
</script>
